import React from 'react';

export default function CustomSpinInput({ value, onChange, min = 1, max = 2400, step = 1, ...props }) {
  const handleUp = () => {
    if (value < max) onChange(Number(value) + step);
  };
  const handleDown = () => {
    if (value > min) onChange(Number(value) - step);
  };

  return (
    <div className="custom-spin-input-wrap">
      <input
        type="number"
        value={value === undefined || value === null ? '' : value}
        step={props.name && props.name.toString().toLowerCase().includes('hour') ? 1 : step}
        inputMode={props.name && props.name.toString().toLowerCase().includes('hour') ? 'numeric' : undefined}
        onChange={e => {
          let val = e.target.value;
          // Prevent decimals for hours: strip decimal part
          if (props.name && props.name.toString().toLowerCase().includes('hour')) {
            if (val.includes('.')) {
              val = val.split('.')[0];
            }
          }
          if (val === '') {
            onChange(null);
          } else {
            onChange(Number(val));
          }
        }}
        onKeyDown={e => {
          if (props.name && props.name.toString().toLowerCase().includes('hour') && e.key === '.') {
            e.preventDefault();
          }
        }}
        onPaste={e => {
          if (props.name && props.name.toString().toLowerCase().includes('hour')) {
            const paste = (e.clipboardData || window.clipboardData).getData('text');
            if (paste.includes('.')) {
              e.preventDefault();
            }
          }
        }}
        min={min}
        max={max}
        {...props}
      />
      <div className="custom-spin-arrows-btns">
        <button type="button" className="arrow-btn up" onClick={handleUp} tabIndex={-1}>
          ▲
        </button>
        <button type="button" className="arrow-btn down" onClick={handleDown} tabIndex={-1}>
          ▼
        </button>
      </div>
    </div>
  );
} 